<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      size="small"
      :loading="loading"
      resizable
      border
      :expand-config="{ reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('goods_package_dialog_title') || '订单产品'
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              :disabled="disabled"
              variant="outline-success"
              @click="openChooseGoods()"
              >{{ $l('goods_package_add_goods') || '添加产品' }}
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="batchDel()"
              :disabled="disabled"
            >
              <i class="el-icon-delete" />
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <choose-order-goods-dialog
      :visible.sync="orderGoodsDialogVisible"
      :title="
        $l('INDEX.order_goods_label_orderGoods_information') || '订单产品信息'
      "
      :orderCode="orderCode"
      @confirm="orderGoodsConfirm"
      type="checkbox"
    />
  </div>
</template>
<script>
import ChooseOrderGoodsDialog from '@/views/factory/components/choose-order-goods/dialog.vue'
export default {
  mixins: [],
  components: { ChooseOrderGoodsDialog },
  props: {
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableHeight: 350,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          type: 'checkbox',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 60,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
          field: 'orderGoodsNo',
          width: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.order_goods_label_identifyGoodsNo') ||
            '产品识别编号',
          field: 'identifyGoodsNo',
          width: 240,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.order_goods_label_orderGoodsName') || '产品名称',
          field: 'orderGoodsDisplayName',
          width: 500,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
      tableData: [],
      orderGoodsDialogVisible: false,
    }
  },
  methods: {
    getTableData() {
      const data = this.tableData.map((i) => {
        return i.orderGoodsCode
      })
      return data
    },
    openChooseGoods() {
      this.orderGoodsDialogVisible = true
    },
    orderGoodsConfirm(data) {
      if (!data || !data.length) return
      const tableData = data
        .map((i) => {
          return {
            orderGoodsCode: i.orderGoodsCode,
            orderGoodsNo: i.orderGoodsNo,
            identifyGoodsNo: i.identifyGoodsNo,
            orderGoodsDisplayName: i.orderGoodsDisplayName,
          }
        })
        .filter(
          (i) =>
            this.tableData.findIndex((j) => j.orderGoodsNo === i.orderGoodsNo) <
            0
        )
      this.tableData.push(...tableData)
    },
    // 批量删除
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) return

      this.$confirm('您确定要删除所勾选数据吗?').then((type) => {
        if (type === 'confirm') {
          this.$refs.vxeGrid.removeCheckboxRow()
          data.forEach((item) => {
            this.tableData.forEach((row, index) => {
              if (row.orderGoodsNo === item.orderGoodsNo) {
                this.tableData.splice(index, 1)
              }
            })
          })
        }
      })
    },
    //单行删除
    del(row) {
      this.$confirm('您确定要删除该数据吗?').then((type) => {
        if (type === 'confirm') {
          let index = this.$refs.vxeGrid.getRowIndex(row)
          this.tableData.splice(index, 1)
        }
      })
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
  },
}
</script>
